import { useMutation } from '@tanstack/react-query';

import { postReferral } from '@/services/api/referral';
import { unsetReferralCode } from '@/utils/referral';

const useReferralPostMutation = () => {
  return useMutation({
    mutationFn: (referralCode: string) => postReferral(referralCode),
    onSuccess: () => unsetReferralCode(),
  });
};

export { useReferralPostMutation };
